/**
 * Trigger a browser-side file download for a Blob. Used for JSON backup export
 * and CSV report export. No-ops outside a document environment (e.g. SSR/tests).
 */
export function downloadBlob(blob: Blob, fileName: string): void {
  if (typeof document === "undefined") {
    return;
  }

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.style.display = "none";
  document.body.append(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 0);
}

export function downloadText(text: string, fileName: string, mimeType: string): void {
  downloadBlob(new Blob([text], { type: `${mimeType};charset=utf-8` }), fileName);
}
